import { Controller } from "@hotwired/stimulus"

/**
 * Script Editor Controller
 * Handles text input for the script step with word/scene counting
 */
export default class extends Controller {
  static targets = ["textarea", "form", "wordCount", "sceneCount"]

  connect() {
    this.updateCounts()
  }

  textareaTargetConnected() {
    this.updateCounts()
    this.textareaTarget.addEventListener("input", () => this.updateCounts())
  }

  updateCounts() {
    if (!this.hasTextareaTarget) return

    const text = this.textareaTarget.value.trim()

    // Count words
    const words = text.split(/\s+/).filter(w => w.length > 0)
    const wordCount = words.length

    // Count scenes (paragraphs separated by double newlines)
    const scenes = text.split(/\n\s*\n+/).filter(p => p.trim().length > 0)
    const sceneCount = scenes.length

    // Update displays
    if (this.hasWordCountTarget) {
      this.wordCountTarget.textContent = `${wordCount} word${wordCount === 1 ? "" : "s"}`
    }

    if (this.hasSceneCountTarget) {
      this.sceneCountTarget.textContent = `${sceneCount} scene${sceneCount === 1 ? "" : "s"}`
    }
  }
}
